export const BASE_API_URL = import.meta.env.VITE_API; //"https://api.on-bible.com";

export const REFERRAL_MENTOR_TOKEN = "/v1/referral/mentor/token";
export const REFERRAL_MENTOR_BIND = "/v1/referral/mentor";
